import { render, staticRenderFns } from "./publishingTrends.vue?vue&type=template&id=064a1eb5&scoped=true&"
import script from "./publishingTrends.vue?vue&type=script&lang=js&"
export * from "./publishingTrends.vue?vue&type=script&lang=js&"
import style0 from "./publishingTrends.vue?vue&type=style&index=0&id=064a1eb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a1eb5",
  null
  
)

export default component.exports